/* eslint-disable */
import AeroCRS from './supplierLogos/aeroCRS.svg';
import Aerticket from './supplierLogos/aerticket.svg';
import Amadeus from './supplierLogos/amadeus.svg';
import AmericanAirlines from './supplierLogos/americanAirlines.svg';
import Apollo from './supplierLogos/apollo.svg';
import AutoEurope from '../car/supplierLogos/autoEurope.svg';
import BritishAir from './supplierLogos/britishAir.svg';
import Duffel from './supplierLogos/duffel.svg';
import Ebeds from '../hotel/supplierLogos/ebeds.svg';
import Emirates from './supplierLogos/emirates.svg';
import FirstCarRental from '../car/supplierLogos/firstCarRental.svg';
import FlySafari from './supplierLogos/flySafari.svg';
import Galileo from './supplierLogos/galileo.svg';
import Lufthansa from './supplierLogos/lufthansa.svg';
import Mango from './supplierLogos/mango.svg';
import Pyton from './supplierLogos/pyton.svg';
import Sabre from './supplierLogos/sabre.svg';
import SingapoorAirlines from './supplierLogos/singapoorAirlines.svg';
import Travelfusion from './supplierLogos/travelfusion.svg';
import UnitedAirlines from './supplierLogos/unitedAirlines.svg';
import Welltravel from './supplierLogos/welltravel.svg';
import Worldspan from './supplierLogos/worldspan.svg';

const suppliers = {
  amadeus: {
    logo: Amadeus,
    supportManageBooking: true,
    supportNdcBooking: false,
    supportCreateQuote: true,
    supportFlexibleCancelation: true,
    supportIssueTicket: true,
    supportVoidTicket: true,
    supportRefundTicket: true,
    supportChangeBooking: true,
  },
  galileo: {
    logo: Galileo,
    supportManageBooking: true,
    supportNdcBooking: false,
    supportCreateQuote: true,
    supportFlexibleCancelation: true,
    supportIssueTicket: true,
    supportVoidTicket: true,
    supportRefundTicket: false,
    supportChangeBooking: false,
  },
  sabre: {
    logo: Sabre,
    supportManageBooking: true,
    supportNdcBooking: false,
    supportCreateQuote: true,
    supportFlexibleCancelation: true,
    supportIssueTicket: true,
    supportVoidTicket: true,
    supportRefundTicket: false,
    supportChangeBooking: false,
  },
  lh_group: {
    logo: Lufthansa,
    supportInstantTicket: true,
    supportManageBooking: true,
    supportNdcBooking: true,
    supportCreateQuote: true,
    supportFlexibleCancelation: true,
    supportIssueTicket: false,
    supportVoidTicket: true,
    supportRefundTicket: true,
    supportChangeBooking: true,
  },
  british_airways: {
    logo: BritishAir,
    supportInstantTicket: true,
    supportManageBooking: true,
    supportNdcBooking: true,
    supportCreateQuote: true,
    supportFlexibleCancelation: true,
    supportIssueTicket: false,
    supportVoidTicket: true,
    supportRefundTicket: true,
    supportChangeBooking: true,
  },
  american_airlines: {
    logo: AmericanAirlines,
    supportManageBooking: true,
    supportNdcBooking: true,
    supportCreateQuote: true,
    supportFlexibleCancelation: true,
    supportIssueTicket: false,
    supportVoidTicket: true,
    supportRefundTicket: true,
    supportChangeBooking: true,
  },
  pyton: {
    logo: Pyton,
    supportInstantTicket: true,
    supportManageBooking: false,
    supportNdcBooking: false,
    supportCreateQuote: false,
    supportFlexibleCancelation: false,
    supportIssueTicket: false,
    supportVoidTicket: false,
    supportRefundTicket: false,
    supportChangeBooking: false,
  },
  aero_crs: {
    logo: AeroCRS,
    supportInstantTicket: true,
    supportManageBooking: true,
    supportNdcBooking: false,
    supportCreateQuote: false,
    supportFlexibleCancelation: true,
    supportIssueTicket: true,
    supportVoidTicket: false,
    supportRefundTicket: false,
    supportChangeBooking: false,
  },
  singapore_airlines: {
    logo: SingapoorAirlines,
    supportManageBooking: true,
    supportNdcBooking: true,
    supportCreateQuote: true,
    supportFlexibleCancelation: true,
    supportIssueTicket: false,
    supportVoidTicket: true,
    supportRefundTicket: true,
    supportChangeBooking: true,
  },
  fly_safair: {
    logo: FlySafari,
    supportManageBooking: true,
    supportNdcBooking: false,
    supportCreateQuote: true,
    supportFlexibleCancelation: false,
    supportIssueTicket: false,
    supportVoidTicket: false,
    supportRefundTicket: false,
    supportChangeBooking: false,
  },
  mango: {
    logo: Mango,
    supportInstantTicket: true,
    supportManageBooking: true,
    supportNdcBooking: false,
    supportCreateQuote: true,
    supportFlexibleCancelation: true,
    supportIssueTicket: false,
    supportVoidTicket: false,
    supportRefundTicket: false,
    supportChangeBooking: false,
  },
  travelfusion: {
    logo: Travelfusion,
    supportFlexibleCancelation: false,
    supportIssueTicket: false,
    supportVoidTicket: false,
    supportRefundTicket: false,
    supportChangeBooking: false,
    supportInstantTicket: true,
    supportFlightBooking: true,
    supportAncillaryServices: true,
  },
  united_airlines: {
    logo: UnitedAirlines,
    supportManageBooking: true,
    supportNdcBooking: true,
    supportCreateQuote: true,
    supportFlexibleCancelation: true,
    supportIssueTicket: false,
    supportVoidTicket: true,
    supportRefundTicket: true,
    supportChangeBooking: true,
  },
  aer_ticket: {
    logo: Aerticket,
    supportManageBooking: true,
    supportNdcBooking: false,
    supportCreateQuote: true,
    supportFlexibleCancelation: true,
    supportIssueTicket: true,
    supportVoidTicket: true,
    supportRefundTicket: false,
    supportChangeBooking: false,
  },
  duffel: {
    logo: Duffel,
    supportManageBooking: true,
    supportNdcBooking: false,
    supportCreateQuote: true,
    supportFlexibleCancelation: true,
    supportIssueTicket: false,
    supportVoidTicket: false,
    supportRefundTicket: true,
    supportChangeBooking: false,
  },
  emirates: {
    logo: Emirates,
    supportManageBooking: true,
    supportNdcBooking: true,
    supportCreateQuote: true,
    supportFlexibleCancelation: true,
    supportIssueTicket: false,
    supportVoidTicket: true,
    supportRefundTicket: true,
    supportChangeBooking: true,
  },
  welltravel: {
    logo: Welltravel,
    supportInstantTicket: true,
    supportCreateQuote: false,
    supportFlexibleCancelation: false,
    supportIssueTicket: false,
    supportVoidTicket: false,
    supportRefundTicket: false,
    supportChangeBooking: false,
    supportAncillaryServices: false,
    supportFlightBooking: true,
    duffel: {
      logo: Welltravel,
      supportInstantTicket: true,
      supportCreateQuote: true,
      supportFlexibleCancelation: false,
      supportIssueTicket: false,
      supportVoidTicket: false,
      supportRefundTicket: true,
      supportChangeBooking: true,
      supportAncillaryServices: false,
      supportFlightBooking: true,
    },
    aer_ticket: {
      logo: Welltravel,
      supportInstantTicket: false,
      supportCreateQuote: true,
      supportFlexibleCancelation: true,
      supportIssueTicket: true,
      supportVoidTicket: true,
      supportRefundTicket: true,
      supportChangeBooking: true,
      supportAncillaryServices: false,
      supportFlightBooking: true,
    },
  },
  worldspan: {
    logo: Worldspan,
    supportManageBooking: true,
    supportNdcBooking: false,
    supportCreateQuote: true,
    supportFlexibleCancelation: true,
    supportIssueTicket: true,
    supportVoidTicket: true,
    supportRefundTicket: true,
    supportChangeBooking: false,
  },
  apollo: {
    logo: Apollo,
    supportManageBooking: true,
    supportNdcBooking: false,
    supportCreateQuote: true,
    supportFlexibleCancelation: true,
    supportIssueTicket: true,
    supportVoidTicket: true,
    supportRefundTicket: true,
    supportChangeBooking: false,
  },
  first_car_rental: {
    logo: FirstCarRental,
  },
  auto_europe: {
    logo: AutoEurope,
  },
  ebeds: {
    logo: Ebeds,
  },
};

export default suppliers;
